import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8.19 3.216a.737.737 0 0 1 1.042 0l4.973 4.974a.737.737 0 0 1 0 1.042l-4.973 4.973a.737.737 0 0 1-1.042 0L3.216 9.232a.737.737 0 0 1 0-1.042L8.19 3.216ZM4.779 8.71l3.932 3.931 3.931-3.931-3.931-3.932L4.779 8.71Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.882 7.237a.645.645 0 1 0 0 1.29.645.645 0 0 0 0-1.29Zm0 1.474a.829.829 0 1 0 0-1.658.829.829 0 0 0 0 1.658Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.045 4.045a.737.737 0 0 1 1.042 0L8.403 7.36A.737.737 0 0 1 7.36 8.403L4.045 5.087a.737.737 0 0 1 0-1.042ZM15.301 15.254c.17-.15.225-.305.225-.43l-.001-.019a1.52 1.52 0 0 0-.076-.269 4.094 4.094 0 0 0-.323-.636 9.386 9.386 0 0 0-.613-.879c-.218.28-.433.582-.613.879a4.094 4.094 0 0 0-.323.636 1.52 1.52 0 0 0-.075.269l-.002.019c0 .125.054.28.225.43.174.152.448.272.788.272s.615-.12.788-.272ZM14.513 17C15.887 17 17 16.026 17 14.824c0-1.006-1.043-2.404-1.778-3.264a.924.924 0 0 0-1.418 0c-.735.86-1.778 2.258-1.778 3.264 0 1.202 1.114 2.176 2.487 2.176Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
